import { Link } from 'react-router-dom';
import { SkipLink } from '../../components/a11y/SkipLink';

export function NotFound() {
  return (
    <>
      <SkipLink />
      <main id="main-content" tabIndex={-1}>
        <h1>Page not found</h1>
        <p>The page you are looking for does not exist.</p>
        <p>
          <Link to="/">Go back home</Link>
        </p>
      </main>
    </>
  );
}
